(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/focus-trap/assets/javascripts/focus-trap.js') >= 0) return;  svs.modules.push('/components/lb-utils/focus-trap/assets/javascripts/focus-trap.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  constants
} = svs.components.lbUtils.focusTrap;
const logger = svs.core.log.getLogger('components:lb-utils:focus-trap:focus-trap');

function handleKeyDown(_ref) {
  let {
    e,
    state,
    onEscape,
    releaseFocus
  } = _ref;
  const {
    first,
    last,
    target
  } = state;
  if (!target) {
    return;
  }
  if (e.key === 'Tab') {
    if (document.activeElement === first && e.shiftKey) {
      e.preventDefault();
      last.focus();
    }
    if (document.activeElement === last && !e.shiftKey) {
      e.preventDefault();
      first.focus();
    }
  } else if (e.key === 'Escape') {
    e.preventDefault();
    if (onEscape) {
      onEscape();
    } else {
      releaseFocus();
    }
  }
}

function createFocusTrap() {
  var _options$selectors, _options$refocus, _options$onEscape, _options$ariaHiddenEl;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!Array.isArray(options.ariaHiddenElements) && options.ariaHiddenElements !== undefined) {
    throw new Error('ariaHiddenElements has to be an array or undefined');
  }
  if (typeof options.onEscape !== 'function' && options.onEscape !== undefined) {
    throw new Error('onEscape has to be a callback function or undefined');
  }
  if (!Array.isArray(options.selectors) && options.selectors !== undefined) {
    throw new Error('selectors has to be an array or undefined');
  }
  const state = _objectSpread({}, constants.state);
  const selectors = (_options$selectors = options.selectors) !== null && _options$selectors !== void 0 ? _options$selectors : constants.defaultSelectors;
  const refocus = (_options$refocus = options.refocus) !== null && _options$refocus !== void 0 ? _options$refocus : true;
  const onEscape = (_options$onEscape = options.onEscape) !== null && _options$onEscape !== void 0 ? _options$onEscape : null;
  const ariaHiddenElements = (_options$ariaHiddenEl = options.ariaHiddenElements) !== null && _options$ariaHiddenEl !== void 0 ? _options$ariaHiddenEl : [];

  function trapFocus(target, callback) {
    if (!target) {
      logger.warn('No target element provided');
      return;
    }

    state.initiator = document.activeElement;
    const queryString = selectors.join(',');
    const elements = Array.from(target.querySelectorAll(queryString)).filter(el => el.hasAttribute('tabindex') ? el.tabIndex > -1 : true);
    if (elements.length === 0) {
      logger.warn('No focusable elements found inside the target');
      return;
    }
    state.target = target;
    state.focusableElements = elements;
    state.first = elements[0];
    state.last = elements[elements.length - 1];
    requestAnimationFrame(() => {
      if (ariaHiddenElements !== null && ariaHiddenElements !== void 0 && ariaHiddenElements.length) {
        document.querySelectorAll(ariaHiddenElements).forEach(element => {
          if (element) {
            element.setAttribute('aria-hidden', true);
          }
        });
      }
      if (state.first) {
        state.first.focus();
      } else {
        target.setAttribute('tabindex', '-1');
        target.focus();
      }
      if (callback) {
        callback({
          el: target,
          focusableElements: elements
        });
      }
    });
  }

  function releaseFocus(newFocusEl, callback) {
    const {
      target,
      initiator
    } = state;
    const elementToFocus = newFocusEl || (refocus ? initiator : null);

    state.target = null;
    state.focusableElements = [];
    state.first = null;
    state.last = null;
    state.onEscape = null;
    if (ariaHiddenElements !== null && ariaHiddenElements !== void 0 && ariaHiddenElements.length) {
      document.querySelectorAll(ariaHiddenElements).forEach(element => {
        if (element) {
          element.setAttribute('aria-hidden', false);
        }
      });
    }

    if (elementToFocus) {
      requestAnimationFrame(() => {
        elementToFocus.focus();
      });
    }
    if (callback) {
      callback({
        el: target,
        newFocus: elementToFocus
      });
    }
  }
  const keyDownHandler = e => handleKeyDown({
    e,
    state,
    onEscape,
    releaseFocus
  });
  function init() {
    document.addEventListener('keydown', keyDownHandler);
  }
  function destroy() {
    if (state !== null && state !== void 0 && state.target) {
      releaseFocus();
    }
    document.removeEventListener('keydown', keyDownHandler);
  }
  init();
  return {
    trapFocus,
    releaseFocus,
    destroy
  };
}
setGlobal('svs.components.lbUtils.focusTrap.createFocusTrap', createFocusTrap);

 })(window);